import scenarioGroupsSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";

export const scenarioGroupActions = { ...actions, ...thunkActions };
export * as ScenarioGroupTypes from "./types";
export default scenarioGroupsSlice;
